<template>
    <div class="expanding-textarea focus:text-lg lg:text-xxs">
        <textarea
            :id="id"
            :name="name"
            :value="value"
            class="input"
            :required="required"
            :autofocus="autofocus"
            :placeholder="placeholder"
            @input="$emit('input', $event.target.value)"
        />

        <slot />

        <div v-if="error" class="form-error">
            {{ error }}
        </div>
    </div>
</template>

<script>
    import BackendError from '@/Atlantis/Elements/Form/BackendError';

    export default {
        mixins: [BackendError],
        props: {
            id: {
                type: String,
                default: null,
            },
            name: {
                type: String,
                default: null,
            },
            value: {
                type: String,
                default: null,
            },
            required: {
                type: Boolean,
                default: false,
            },
            autofocus: {
                type: Boolean,
                default: false,
            },
            placeholder: {
                type: String,
                default: null,
            },
        },
    };
</script>
